import 'jquery.cookie';

export default () => {
    const platform = window.appConfig.isMobileDomain ? 'mobile' : 'desktop';
    window.dataLayer = window.dataLayer || [];

    const enabledCookie = $.cookie(`ab_enabled_${platform}`);
    const versionCookie = $.cookie(`ab_version_${platform}`);
    const expuuid = `${enabledCookie === '1' ? 'b' : 'a'}_${versionCookie}`;

    window.dataLayer.push({
        event: 'exp_def',
        expuuid,
        pType: window.appConfig.pageType || 'infoPage',
    });
};